<template>
   <v-col md="12" style="height: 100%;" class="pt-4 pb-12 mt-0">  
    <v-row justify="center" align="center" style=" max-width: 700px; margin: 0 auto; height: 100%" class="pt-0">
      <v-col style="background-color: whitesmoke; min-height: 550; max-width: 355px" class="elevation-4">
        <v-row justify="center" class="pb-3">
          <h1>Alta Domicilio</h1>
        </v-row>
        <v-row style="width: 90%; margin: 0 auto;">
          <v-text-field v-model="address.calle" label="Calle" single-line solo></v-text-field>
            <v-row justify="center">
              <v-col md="6">
                <v-row justify="center" style="margin: 0 auto">
                  <v-text-field v-model="address.num_exterior" label="No. Exterior" single-line solo></v-text-field>
                </v-row>
              </v-col>
              <v-col md="6">
                <v-row justify="center" style="margin: 0 auto">
                  <v-text-field v-model="address.num_interior" label="No. Interior" single-line solo></v-text-field>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col md="6">
                <v-row justify="center" style="margin: 0 auto">
                  <v-text-field v-model="address.cp" label="Código Postal" single-line solo></v-text-field>
                </v-row>
              </v-col>
              <v-col md="6">
                <v-row justify="center" style="margin: 0 auto">
                  <v-text-field v-model="address.alias" label="Tipo" single-line solo></v-text-field>
                </v-row>
              </v-col>
            </v-row>
          <v-text-field v-model="address.colonia" label="Colonia o Fraccionamiento" single-line solo></v-text-field>
          <v-text-field v-model="address.ciudad" label="Municipio" single-line solo></v-text-field>
          <v-text-field v-model="address.estado" label="Estado" single-line solo></v-text-field>
          <v-text-field v-model="address.pais" label="Pais" single-line solo></v-text-field>
          <v-text-field v-model="address.referencias" label="Referencias en la dirección" single-line solo></v-text-field>
          <p1>Llena el formulario para acceder al mapa</p1>
          <!-- <Map v-if="validate==true"  :address="address" class="mapa"/> -->
        </v-row>
        <v-row justify="center" style="margin: 0 auto" class="pt-2 pb-4">
          <v-btn @click="addAddress();" color="black" class="buttonLower" style="color: white" :disabled="checkAddress">Siguiente</v-btn>
        </v-row>

      </v-col>
    </v-row>
  </v-col>
</template>
<script>
//import Map from "./maps/Map.vue"; 
  export default {
    components:{
      //Map 
    },
    data () {
      return {
        address:{
          id_cliente:'',
          alias:'',
          predeterminada:'',
          calle:'',
          num_exterior:'',
          num_interior:'',
          cp:'',
          colonia:'',
          ciudad:'',
          estado:'',
          pais:'',
          referencias:'',
        },
        token:'',
        validate:false,
        longitude:null,
        latitude:null,
      }
    },
    computed:{
      checkAddress: function (){
        if (this.address.calle && this.address.num_exterior && this.address.colonia && this.address.cp && this.address.estado && this.address.ciudad && this.address.referencias) { 
          this.locator();
          return false 
        } return true;
      },
    },
    methods: {
      locator()
      {
        this.validate=true;
        console.log('Entra');
      },
      addAddress(){
        this.token=localStorage.getItem("token");
        this.address.calle=localStorage.getItem("calle");
        this.address.num_exterior=localStorage.getItem("num_exterior");
        this.address.colonia=localStorage.getItem("colonia");
        this.address.ciudad=localStorage.getItem("ciudad");
        this.address.estado=localStorage.getItem("estado");
        this.address.cp=localStorage.getItem("cp");
        this.longitude=localStorage.getItem("longitude");
        this.latitude=localStorage.getItem("latitude");
        //this.token="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE1OTA2ODU2NDksImF1ZCI6IjE3MDc2OGVjN2Y1M2M2ZGE0OGVmNDc1NDAzNmE5ODg2YzkwN2QzMTAiLCJkYXRhIjp7ImlkIjoiOSIsIm5hbWUiOiJlbnJpcXVlLnJhbWlyZXpAc3d5dGkuY29tLm14In19.R6ywm-LJVSwkSKrBEs8MIOwlXfwixn-hGvMb1ngoPuU";
        this.address.alias='name';
        this.address.id_cliente='9';
        this.address.predeterminada='S';
        const addressAdd=this.address;
        console.log(addressAdd);
        console.log(this.token);
        // const Data = {id_cliente: '9', "alias":"Casa", "predeterminada":"S", "calle":"Tomas Vazquez", "num_exterior":"31", 
        // "num_interior":"11","cp":"08210","colonia":"Nueva Santa Anita","ciudad":"Iztacalco","estado":"CDMX","pais":"México","referencias":""}
        // console.log(Data);
        
        this.$store.dispatch("POST", {url: '/altaD', body: addressAdd, headers: {'x-auth-token': this.token}})
            .then(response => {
                console.log(response);
            })// eslint-disable-next-line
            .catch(error => {
                // eslint-disable-next-line
                console.log("Error: " + error);
            });
      }
    },
  }
</script>

<style lang="scss" scoped>
.mapa {
    height: 300px;
  }
</style>